/* eslint-disable */
import React, { useEffect } from 'react';

import ReactModal from 'react-modal';
import closeSvg from 'src/assets/close.svg';

import { CommonInput, RegularButton } from 'pg-ui-library';

import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { IBenefit } from 'src/interfaces';
import { monetaryUSDFormat } from 'src/utils/currencyFormat';
import { useTranslation } from 'react-i18next';
import { CloseIcon, Content, FormRow, FormTitle, Header, SeeDocumentsButton } from './styles';
import { FormButton } from '../sign-submit-modal/styles';
import BenefitsService from 'src/services/benefits.service';

export const BenefitModal: React.FC<{
  isOpen: boolean;
  benefitId: string;
  // eslint-disable-next-line no-unused-vars
  setBenefitModalIsOpen: (b: boolean) => void;
}> = ({ isOpen, benefitId, setBenefitModalIsOpen }) => {
  const { t } = useTranslation();

  const { data } = useTypedSelector(state => state.benefits);

  const selectedBenefit = data.benefits.find((benefit: IBenefit) => benefit.benefitId === benefitId);

  const initValues: Partial<IBenefit> = {
    benefitId: selectedBenefit?.benefitId || '',
    benefitName: selectedBenefit?.benefitName || '',
    benefitProvider: selectedBenefit?.benefitProvider || '',
    employeeName: selectedBenefit?.employeeName || '',
    employerName: selectedBenefit?.employerName || '',
    benefitEnrollmentStart: selectedBenefit?.benefitEnrollmentStart || '',
    benefitEnrollmentEnd: selectedBenefit?.benefitEnrollmentEnd || '',
    employeeCost: selectedBenefit?.employeeCost || 0,
    employerCost: selectedBenefit?.employerCost || 0,
    coveredSpouse: selectedBenefit?.coveredSpouse || [],
    coveredChildren: selectedBenefit?.coveredChildren || [],
    benefitPlanId: selectedBenefit?.benefitPlanId || '',
    benefitOptionId: selectedBenefit?.benefitOptionId || '',
    beneficiaries: selectedBenefit?.beneficiaries || [],
    basis: selectedBenefit?.basis || '',
  };

  const handleModal = () => {
    setBenefitModalIsOpen(!isOpen);
  };

  const handleDocDownload = () => {
    const firstBenefit = selectedBenefit;
    return BenefitsService.planDocDownload(
      firstBenefit?.version || '',
      firstBenefit?.planDocument || '',
      firstBenefit?.type || ''
    );
  };

  const isDownloadButtonDisabled = () => {
    if (
      selectedBenefit &&
      selectedBenefit.version &&
      selectedBenefit.planDocument &&
      selectedBenefit?.type &&
      selectedBenefit.hasPlanDocument === true
    ) {
      return false;
    }
    return true;
  };

  return (
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={handleModal}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '30px',
          margin: 'auto',
          width: '1200px',
          height: 'max-content',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '58px',
        },
      }}
    >
      <Header>
        <FormTitle>{t('benefits.benefit.name')}</FormTitle>
        <CloseIcon src={closeSvg} onClick={() => handleModal()} />
      </Header>

      <Content>
        <FormRow style={{ gridTemplateColumns: '2fr 2fr' }}>
          <CommonInput
            style={{ width: '100%' }}
            disabled
            id="benefit"
            name="benefitName"
            label="Benefit Name"
            value={initValues.benefitName}
          />

          <CommonInput
            style={{ width: '100%' }}
            disabled
            id="benefitProvider"
            name="benefitProvider"
            label="Provider"
            value={initValues.benefitProvider}
          />
        </FormRow>

        <FormRow style={{ gridTemplateColumns: '2fr 2fr' }}>
          <CommonInput
            style={{ width: '100%' }}
            disabled
            id="employeeName"
            name="employeeName"
            label="Employee Name"
            value={initValues.employeeName}
          />

          <CommonInput
            style={{ width: '100%' }}
            disabled
            id="employerName"
            name="employerName"
            label="Employer Name"
            value={initValues.employerName}
          />
        </FormRow>

        <FormRow style={{ gridTemplateColumns: '1fr 1fr 2fr 2fr' }}>
          <CommonInput
            style={{ width: '100%' }}
            disabled
            id="benefitEnrollmentStart"
            name="benefitEnrollmentStart"
            label="Start Date"
            value={initValues.benefitEnrollmentStart}
          />

          <CommonInput
            style={{ width: '100%' }}
            disabled
            id="benefitEnrollmentEnd"
            name="benefitEnrollmentEnd"
            label="End Date"
            value={initValues.benefitEnrollmentEnd}
          />

          <CommonInput
            style={{ width: '100%' }}
            disabled
            id="employeeCost"
            name="employeeCost"
            label="Employee Cost"
            value={
              initValues.basis === 'PercentOfEarnings'
                ? `${(initValues.employeeCost as unknown as 0) * 100 ?? 0}%`
                : monetaryUSDFormat(initValues.employeeCost ?? 0)
            }
          />

          <CommonInput
            style={{ width: '100%' }}
            disabled
            id="employerCost"
            name="employerCost"
            label="Employer Cost"
            value={monetaryUSDFormat(initValues.employerCost ?? 0)}
          />
        </FormRow>

        <FormRow style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
          {initValues.coveredSpouse?.map((spouse, index) => (
            <CommonInput
              style={{ width: '100%' }}
              disabled
              name="coveredSpouse"
              label={index === 0 ? 'Covered Spouse' : ''}
              value={spouse.name}
            />
          ))}
        </FormRow>

        <FormRow style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
          {initValues.coveredChildren?.map((child, index) => (
            <CommonInput
              style={{ width: '100%' }}
              disabled
              name="coveredChildrens"
              label={index === 0 ? 'Covered Childrens' : ''}
              value={child.name}
            />
          ))}
        </FormRow>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            marginTop: '30px',
          }}
        >
          <FormButton disabled={isDownloadButtonDisabled()}>
            {isDownloadButtonDisabled() ? (
              <span>{t('global.form.downloadDoc')}</span>
            ) : (
              <a
                href={handleDocDownload()}
                style={{ color: 'white', textDecoration: 'none' }}
                download
                target="_blank"
                rel="noreferrer"
              >
                {t('global.form.downloadDoc')}
              </a>
            )}
          </FormButton>
        </div>
      </Content>
    </ReactModal>
  );
};
